import * as React from 'react';
import { useAtom } from 'jotai';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as store from '../../store';
import CustomizePopup from '../CustomizePopup';
import FunnelChart from '../FunnelChart';
import Breakdown from './Breakdown';
import Dropoff from './Dropoff';
import * as Styles from './styled';

const Analysis = () => {
  const [activeTab, setActiveTab] = useAtom(store.activeTabAtom);
  const tabItems = React.useMemo(
    () => [
      {
        key: 'breakdown',
        label: 'Conversion Breakdown',
        children: <Breakdown />,
      },
      {
        key: 'dropoff',
        label: 'Gaps & Opportunities',
        children: <Dropoff />,
      },
    ],
    [],
  );

  return (
    <>
      <FunnelChart />
      <Styles.TabsContainer
        activeKey={activeTab}
        onChange={setActiveTab as any}
        items={tabItems}
        size="small"
        destroyOnHidden
        tabBarExtraContent={
          activeTab === 'breakdown' && (
            <CustomizePopup mode="add">
              <Button color="primary" variant="text" icon={<PlusOutlined />}>
                Dimension Table
              </Button>
            </CustomizePopup>
          )
        }
      />
    </>
  );
};

export default React.memo(Analysis);
